var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 17.5V11.25C28 7.10786 24.6421 3.75 20.5 3.75C16.3579 3.75 13 7.10786 13 11.25V17.5M11.75 36.25H29.25C31.3211 36.25 33 34.5711 33 32.5V21.25C33 19.1789 31.3211 17.5 29.25 17.5H11.75C9.67893 17.5 8 19.1789 8 21.25V32.5C8 34.5711 9.67893 36.25 11.75 36.25Z",
    stroke: "#18181B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.f62ba8c98e5937ec910af5413333a833.svg";
export { ForwardRef as ReactComponent };